import { inject, signal, Signal } from '@angular/core';
import {
  UserInformationProvider,
  UserInformationProviderContext,
} from '@xt/user-context';

const emptyUserInformationProviderContext: UserInformationProviderContext = {
  contextIsReady: false,
  person: undefined,
  userInfo: undefined,
};
export function userInformation(): Signal<UserInformationProviderContext> {
  const userInfo = inject(UserInformationProvider, { optional: true });

  return (
    userInfo?.context ||
    signal(emptyUserInformationProviderContext).asReadonly()
  );
}
